<template>
  <div>
    <v-row>
      <v-col cols="12">
        <profile-card>
        </profile-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import ProfileCard from './components/ProfileCard';

export default {
  components: {ProfileCard},
  computed: {
    ...mapGetters([
      'user',
    ])
  }
}
</script>
